<template>
  <gs-named-modal class="gs-refresh-controls gs-aff-modal" name="edit-bonus-modal" :title="$t('frontend_groovesell_bonuses_edit_bonus')" width="600px" max-width="600px" @opened="resetValidation">
    <form id="edit-bonus-modal-form" class="gs-aff-form" @submit.prevent="editBonus()">
      <p>Update the name and delivery link for this bonus.</p>
      <label>{{ $t('frontend_bonuses_name') }}
        <text-input v-model="localModel.name" :validator="$v.localModel.name" :attribute="$t('frontend_name')" :placeholder="$t('frontend_name')" />
      </label>
      <label>{{ $t('frontend_bouses_link') }}
        <text-input v-model="localModel.link" :validator="$v.localModel.link" attribute="Link" placeholder="https://" />
      </label>
    </form>
    <div slot="footer" class="gs-aff-footer">
      <gs-button variant="outline" @click="$root.$emit('modal-close', 'edit-bonus-modal')">{{ $t('frontend_cancel') }}</gs-button>
      <gs-button variant="primary" type="submit" form="edit-bonus-modal-form">{{ $t('frontend_bouses_update') }}</gs-button>
    </div>
  </gs-named-modal>
</template>
<script>
import "../../affiliate-workspace.css";
import { required, minLength, maxLength, url } from 'vuelidate/lib/validators';

export default {
  props: {
    model: {
      type: Object,
      required: true,
    }
  },
  data() {
    return {
      localModel: { ...this.model },
    };
  },
  methods: {
    resetValidation() { this.localModel = { ...this.model }; this.$v.$reset(); },
    editBonus() {
      this.$v.$touch();
      if (!this.$v.$invalid) {
        this.$emit('editBonus', this.localModel);
      }
    },
  },
  validations: {
    localModel: {
      name: {
        required,
        minLength: minLength(3),
        maxLength: maxLength(80)
      },
      link: {
        required,
        url
      }
    }
  },
};
</script>
